<div class="mat-card">
    <div class="p-16">
        <div class="h1 pr-16">Servicios Seleccionados</div>
    </div>

    <table class="simple">
        <thead>
            <tr>
                <th>Servicio</th>
                <th class="text-right">Cantidad</th>
                <th class="text-right">Tiempo</th>
                <th class="text-right"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let servicioSeleccionado of serviciosSeleccionados">
                <td
                    (click)="editar(servicioSeleccionado)"
                    class="cursor-pointer"
                >
                    <small
                        ><strong>
                            {{ servicioSeleccionado.servicio.descripcion }} -
                            {{
                                servicioSeleccionado.servicio.atributos.join(
                                    ", "
                                )
                            }} </strong
                        >( {{ servicioSeleccionado.servicio.nombreSucursal }})
                        <mat-icon color="accent">edit</mat-icon>
                    </small>
                </td>
                <td class="text-right">
                    {{
                        servicioSeleccionado.detalle.cantidad
                            ? servicioSeleccionado.detalle.cantidad
                            : "-"
                    }}
                    {{
                        servicioSeleccionado.servicio.unidadMedida?.descripcion
                    }}
                </td>
                <td class="text-right">
                    {{
                        servicioSeleccionado.detalle.tiempo
                            ? servicioSeleccionado.detalle.tiempo
                            : "-"
                    }}
                    {{
                        servicioSeleccionado.servicio.unidadTiempo?.descripcion
                    }}
                </td>
                <td class="text-right">
                    <button
                        mat-icon-button
                        color="warn"
                        (click)="
                            quitar(
                                servicioSeleccionado.servicio.id,
                                servicioSeleccionado.servicio
                                    .sucursalSeleccionada
                            )
                        "
                    >
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="card-divider full-width"></div>

    <div class="p-8 pt-16">
        <div class="text-bold text-right">Total estimado</div>
        <div class="text-right mat-headline">
            UF {{ total.totalMinUF }} - {{ total.totalMaxUF }}
            <br />
            <small class="primary p-4">
                {{ total.totalMinCLP | currency: "CLP":"symbol-narrow" }} -
                {{ total.totalMaxCLP | currency: "CLP":"symbol-narrow" }}
            </small>
        </div>
    </div>
</div>
